import { fromJS } from 'immutable';
import { useMemo, useState, useEffect } from 'react';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { H7 } from 'foundations-components/transitional/components/H7';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FilterOperatorErrorRecord from 'customer-data-filters/filterQueryFormat/FilterOperatorErrorRecord';
// @ts-expect-error untyped import
import FilterOperatorRefinableInput from 'customer-data-filters/components/operator/FilterOperatorRefinableInput';
// @ts-expect-error untyped import
import Any from 'customer-data-filters/filterQueryFormat/operator/Any';
// @ts-expect-error untyped import
import ReferenceInputEnum from 'customer-data-reference-ui-components/ReferenceInputEnum';
// @ts-expect-error untyped import
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error untyped import
import { INBOUND_DB_LISTS } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { REPORTING_LEGACY_OPERATOR_USAGE } from 'reporting-data/constants/trackingMetrics';
import { getOperatorsListMembership, listMembershipFromObjectSegFilterStrict, listMembershipToObjectSegFilterStrict, getReferencedObjectTypeListMembership, getInputComponentListMembership } from '../../list-membership-utils';
import { InboundDbListMembershipSnowflakeProperty } from '../../../../metadata/lists';
// @ts-expect-error untyped import
import { CloneFilterSelect } from '../shared/CloneFilterSelect';
// @ts-expect-error untyped import
import { GroupFilterControl } from '../shared/GroupFilterControl';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import { useTableSource } from '../SourceMeta';
import { hasObjectTypeId } from '../../../../utils/source-utils';
import { getObjectTypeFamily, getOperatorLabel, getPlaceholder, toDSFieldRecord, toObjectSegAny
// @ts-expect-error untyped import
} from '../../xo-filter-utils';
import { Metrics } from '../../../../../shared/Metrics';
import { getIsUngatedToSnowflakePropertyFilterMigration } from '../../../../utils/filter-utils';
import ListMembershipFilter from './ListMembershipFilter';
import ListOperatorSelect from './ListOperatorSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NO_ERROR = FilterOperatorErrorRecord({
  error: false
});
const getMappedProps = (filter, source, resolvers, userGates) => {
  const {
    filter: listFilter
  } = filter;
  const field = toDSFieldRecord(InboundDbListMembershipSnowflakeProperty, source, userGates);
  const filterFamily = hasObjectTypeId(source) ? getObjectTypeFamily(source.objectTypeId) : source.dataSourceId;
  const operator = listFilter && listFilter.get('operator') ? listMembershipFromObjectSegFilterStrict(listFilter.toJS()) : Any.of(field);
  const getFamilyValueResolver = () => resolvers[INBOUND_DB_LISTS];
  return {
    currencyCode: 'USD',
    error: NO_ERROR,
    showIncludeUnknownValues: false,
    isFiscalYearEnabled: false,
    isRollingDateOffsetInputEnabled: false,
    isXoEnabled: true,
    filterFamily,
    getIsUngated: gate => getIsUngated(gate, userGates),
    getDefaultTimezone: () => I18n.moment.portalTz().tz(),
    getFilterFamilyObjectName: () => '',
    getObjectPropertyLabel: () => '',
    getOperatorLabel,
    getLabelString: () => I18n.text('reporting-snowflake.filter-editor.list-membership.field-name'),
    getInputComponent: getInputComponentListMembership,
    getReferencedObjectType: getReferencedObjectTypeListMembership,
    getFamilyValueResolver,
    getSpecialOptionsForReferenceType: () => undefined,
    getPlaceholder: () => getPlaceholder(operator),
    getOperators: getOperatorsListMembership,
    value: operator
  };
};
const ListFilterPanel = ({
  filter,
  groupId,
  resolvers,
  onDone,
  onCancel,
  onCloneFilter
}) => {
  const [draftFilter, setDraft] = useState(filter);
  const [draftGroupId, setGroup] = useState(groupId);
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const draftListId = draftFilter.getIn(['filter', 'listId']);
  const draftOperator = draftFilter.getIn(['filter', 'operator']);
  const isUngatedToSnowflakeFilterMigration = getIsUngatedToSnowflakePropertyFilterMigration(userGates);
  const {
    field: {
      table: tableName
    }
  } = filter;
  const source = useTableSource(tableName);
  const mappedProps = useMemo(() => getMappedProps(draftFilter, source, resolvers, userGates), [draftFilter, source, resolvers, userGates]);
  const handleListIdChange = ({
    target: {
      value: listId
    }
  }) => setDraft(draftFilter.setIn(['filter', 'listId'], listId));
  const handleListMembershipChange = listId => {
    setDraft(draftFilter.setIn(['filter', 'listId'], listId));
  };
  const handleOperatorChange = ({
    target: {
      value: operator
    }
  }) => {
    const nextObjectSegFilter = operator instanceof Any ? toObjectSegAny(operator) : listMembershipToObjectSegFilterStrict(operator.setIn(['field', 'name'], draftListId));
    setDraft(draftFilter.set('filter', fromJS(nextObjectSegFilter)));
  };

  // Handler for the new ListOperatorSelect component
  const handleNewOperatorChange = ({
    target: {
      value: operator
    }
  }) => {
    const nextObjectSegFilter = operator instanceof Any ? toObjectSegAny(operator) : listMembershipToObjectSegFilterStrict(operator.setIn(['field', 'name'], draftListId));
    setDraft(draftFilter.set('filter', fromJS(nextObjectSegFilter)));
  };
  const handleDone = () => {
    onDone({
      draftFilter,
      draftGroupId
    });
  };
  const handleCloneFilter = groupIndex => {
    onCloneFilter({
      draftFilter,
      groupId: groupIndex
    });
  };
  useEffect(() => {
    if (!isUngatedToSnowflakeFilterMigration) {
      Metrics.counter(REPORTING_LEGACY_OPERATOR_USAGE, {
        propertyType: 'list-filter'
      }).increment();
    }
  }, [isUngatedToSnowflakeFilterMigration]);
  const headerText = I18n.text('reporting-snowflake.filter-editor.list-membership.field-name');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H7, {
      children: headerText
    }), !isUngatedToSnowflakeFilterMigration ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: "list-select",
        children: I18n.text('reporting-snowflake.filter-editor.list-membership.select-list')
      }), /*#__PURE__*/_jsx(ReferenceInputEnum, {
        id: "list-select",
        searchable: true,
        resolver: resolvers[INBOUND_DB_LISTS],
        value: draftListId && draftListId.toString(),
        onChange: handleListIdChange,
        requestOptions: {
          listFilterProperties: {
            includeDeletes: false,
            objectTypeId: source.objectTypeId
          }
        }
      })]
    }) : null, /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "operator-select",
      children: I18n.text('reporting-snowflake.filter-editor.list-membership.select-operator')
    }), isUngatedToSnowflakeFilterMigration ? /*#__PURE__*/_jsx(ListOperatorSelect, {
      id: "operator-select",
      value: mappedProps.value,
      onChange: handleNewOperatorChange
    }) : /*#__PURE__*/_jsx(FilterOperatorRefinableInput, Object.assign({
      id: "operator-select",
      onChange: handleOperatorChange
    }, mappedProps)), isUngatedToSnowflakeFilterMigration ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: "list-select",
        children: I18n.text('reporting-snowflake.filter-editor.list-membership.select-list')
      }), /*#__PURE__*/_jsx(ListMembershipFilter, {
        filteredLists: !isNaN(Number(draftListId)) ? [Number(draftListId)] : [],
        objectType: source.objectTypeId,
        onChange: handleListMembershipChange
      })]
    }) : null, /*#__PURE__*/_jsx(GroupFilterControl, {
      currentGroupId: draftGroupId,
      onGroupSelected: nextGroupId => setGroup(nextGroupId)
    }), /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          size: "xs",
          onClick: handleDone,
          disabled: !draftListId || !draftOperator,
          children: I18n.text('reporting-snowflake.filter-editor.editor-panel.apply')
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          onClick: onCancel,
          children: I18n.text('reporting-snowflake.filter-editor.editor-panel.cancel')
        })]
      }), /*#__PURE__*/_jsx(CloneFilterSelect, {
        currentGroupId: groupId,
        onCloneFilter: handleCloneFilter
      })]
    })]
  });
};
export default ConnectReferenceResolvers(resolvers => ({
  resolvers
}))(ListFilterPanel);